export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const LOGIN = "LOGIN";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_POST_ERROR = "LOGIN_POST_ERROR";
export const FETCH_DATA = "FETCH_DATA";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const SESSION_INVALID = "Session invalid";
export const DDOS_SUSPECTED = "DDOS SUSPECTED";
export const POST_ERROR = "POST_ERROR";
export const FETCH_USER_TIMEOUT = "FETCH_USER_TIMEOUT";
export const REGISTER_PACKAGE_ERROR = "REGISTER_PACKAGE_ERROR";
export const REGISTER_PACKAGE_SUCCESS = "REGISTER_PACKAGE_SUCCESS";
export const UPLOAD_ERROR = "UPLOAD_ERROR";
export const UPLOAD_SUCCESS = "UPLOAD_SUCCESS";
export const DOWNLOAD_ERROR = "DOWNLOAD_ERROR";
export const DOWNLOAD_SUCCESS = "DOWNLOAD_SUCCESS";
export const PUBLISH_ERROR = "PUBLISH_ERROR";
export const PUBLISH_SUCCESS = "PUBLISH_SUCCESS";
export const UPDATE_USERS_TO_ACTIVE_SUCCESS = "UPDATE_USERS_TO_ACTIVE_SUCCESS";
export const UPDATE_USERS_TO_ACTIVE_ERROR = "UPDATE_USERS_TO_ACTIVE_ERROR";
export const UPDATE_USERS_TO_INACTIVE_SUCCESS = "UPDATE_USERS_TO_INACTIVE_SUCCESS";
export const UPDATE_USERS_TO_INACTIVE_ERROR = "UPDATE_USERS_TO_INACTIVE_ERROR";
export const COUNT_USER_ERROR = "COUNT_USER_ERROR";
export const COUNT_USER_SUCCESS = "COUNT_USER_SUCCESS";
export const CHECK_ROLE_SUCCESS = "CHECK_ROLE_SUCCESS";
export const CHECK_ROLE_ERROR = "CHECK_ROLE_ERROR";
export const CHECK_ROLE_POST_ERROR = "CHECK_ROLE_POST_ERROR";
export const FETCH_FILE_SUCCESS = "FETCH_FILE_SUCCESS";
export const FETCH_FILE_ERROR = "FETCH_FILE_ERROR";
export const FETCH_LAYER_SUCCESS = "FETCH_LAYER_SUCCESS";
export const FETCH_LAYER_ERROR = "FETCH_LAYER_ERROR";
export const FETCH_PORTRAYLAYER_SUCCESS = "FETCH_PORTRAYLAYER_SUCCESS";
export const FETCH_PORTRAYLAYER_ERROR = "FETCH_PORTRAYLAYER_ERROR";
export const UPDATE_LAYER_ORDER_SUCCESS = "UPDATE_LAYER_ORDER_SUCCESS";
export const UPDATE_LAYER_ORDER_ERROR = "UPDATE_LAYER_ORDER_ERROR";
export const LAYER_PUBLISH_STASH_SUCCESS = "LAYER_PUBLISH_STASH_SUCCESS";
export const LAYER_PUBLISH_STASH_ERROR = "LAYER_PUBLISH_STASH_ERROR";
export const GET_ALL_PACKAGE_SUCCESS = "GET_ALL_PACKAGE_SUCCESS";
export const GET_ALL_PACKAGE_ERROR = "GET_ALL_PACKAGE_ERROR";
export const GET_NOT_EXPIRED_PACKAGES_SUCCESS = "GET_NOT_EXPIRED_PACKAGES_SUCCESS";
export const GET_NOT_EXPIRED_PACKAGES_ERROR = "GET_NOT_EXPIRED_PACKAGES_ERROR";
export const GET_NOT_EXPIRED_PACKAGES_POST_ERROR = "GET_NOT_EXPIRED_PACKAGES_POST_ERROR";
export const REGISTER_PACKAGE_POST_ERROR = "REGISTER_PACKAGE_POST_ERROR";
export const CHECK_PACKAGE_POST_ERROR = "CHECK_PACKAGE_POST_ERROR";
export const UPLOAD_POST_ERROR = "UPLOAD_POST_ERROR";
export const UPDATE_USERS_TO_ACTIVE_POST_ERROR = "UPDATE_USERS_TO_ACTIVE_POST_ERROR";
export const UPDATE_USERS_TO_INACTIVE_POST_ERROR = "UPDATE_USERS_TO_INACTIVE_POST_ERROR";
export const COUNT_USER_POST_ERROR = "COUNT_USER_POST_ERROR";
export const UPDATE_LAYER_ORDER_POST_ERROR = "UPDATE_LAYER_ORDER_POST_ERROR";
export const LAYER_PUBLISH_STASH_POST_ERROR = "LAYER_PUBLISH_STASH_POST_ERROR";
export const FETCH_PORTRAYLAYER_POST_ERROR = "FETCH_PORTRAYLAYER_POST_ERROR";
export const FETCH_LAYER_POST_ERROR = "FETCH_LAYER_POST_ERROR";
export const FILE_PUBLISH_REMOVE_POST_ERROR = "FILE_PUBLISH_REMOVE_POST_ERROR";
export const FILE_PUBLISH_REMOVE_ERROR = "FILE_PUBLISH_REMOVE_ERROR";
export const FILE_PUBLISH_REMOVE_SUCCESS = "FILE_PUBLISH_REMOVE_SUCCESS";
export const FETCH_FILE_POST_ERROR = "FETCH_FILE_POST_ERROR";
export const COUNT_FILE_POST_ERROR = "COUNT_FILE_POST_ERROR";
export const COUNT_FILE_ERROR = "COUNT_FILE_ERROR";
export const COUNT_FILE_SUCCESS = "COUNT_FILE_SUCCESS";
export const COUNT_LAYER_POST_ERROR = "COUNT_LAYER_POST_ERROR";
export const COUNT_LAYER_ERROR = "COUNT_LAYER_ERROR";
export const COUNT_LAYER_SUCCESS = "COUNT_LAYER_SUCCESS";
export const FETCH_USER_TO_SHARE_PORTRAYAL_POST_ERROR = "FETCH_USER_TO_SHARE_PORTRAYAL_POST_ERROR";
export const FETCH_USER_TO_SHARE_PORTRAYAL_ERROR = "FETCH_USER_TO_SHARE_PORTRAYAL_ERROR";
export const FETCH_USER_TO_SHARE_PORTRAYAL_SUCCESS = "FETCH_USER_TO_SHARE_PORTRAYAL_SUCCESS";
export const SHARE_LAYER_TO_SELECTED_USER_POST_ERROR = "SHARE_LAYER_TO_SELECTED_USER_POST_ERROR";
export const SHARE_LAYER_TO_SELECTED_USER__ERROR = "SHARE_LAYER_TO_SELECTED_USER__ERROR";
export const SHARE_LAYER_TO_SELECTED_USER__SUCCESS = "SHARE_LAYER_TO_SELECTED_USER__SUCCESS";
export const UPDATE_LAYER_STATUS_SUCCESS = "UPDATE_LAYER_STATUS_SUCCESS";
export const UPDATE_LAYER_STATUS_ERROR = "UPDATE_LAYER_STATUS_ERROR";
export const UPDATE_LAYER_STATUS_POST_ERROR = "UPDATE_LAYER_STATUS_POST_ERROR";
export const FETCH_MAIN_USER_SUCCESS = "FETCH_MAIN_USER_SUCCESS";
export const FETCH_MAIN_USER_ERROR = "FETCH_MAIN_USER_ERROR";
export const FETCH_MAIN_USER_POST_ERROR = "FETCH_MAIN_USER_POST_ERROR";
export const DOWNLOAD_POST_ERROR = "DOWNLOAD_POST_ERROR";
export const REGISTER_SUB_USER_SUCCESS = "REGISTER_SUB_USER_SUCCESS";
export const REGISTER_SUB_USER_ERROR = "REGISTER_SUB_USER_ERROR";
export const REGISTER_SUB_USER_POST_ERROR = "REGISTER_SUB_USER_POST_ERROR";
export const COUNT_MAIN_USER_SUCCESS = "COUNT_MAIN_USER_SUCCESS";
export const COUNT_MAIN_USER_ERROR = "COUNT_MAIN_USER_ERROR";
export const COUNT_MAIN_USER_POST_ERROR = "COUNT_MAIN_USER_POST_ERROR";
export const FETCH_PLAIN_USER_SUCCESS = "FETCH_PLAIN_USER_SUCCESS";
export const FETCH_PLAIN_USER_ERROR = "FETCH_PLAIN_USER_ERROR";
export const FETCH_PLAIN_USER_ERROR_POST = "FETCH_PLAIN_USER_ERROR_POST";
export const COUNT_PLAIN_USER_SUCCESS = "COUNT_PLAIN_USER_SUCCESS";
export const COUNT_PLAIN_USER_ERROR = "COUNT_PLAIN_USER_ERROR";
export const COUNT_PLAIN_USER_POST_ERROR = "COUNT_PLAIN_USER_POST_ERROR";
export const COUNT_PUBLISH_LAYER_VIEW_SUCCESS = "COUNT_PUBLISH_LAYER_VIEW_SUCCESS";
export const COUNT_PUBLISH_LAYER_VIEW_ERROR = "COUNT_PUBLISH_LAYER_VIEW_ERROR";
export const COUNT_PUBLISH_LAYER_VIEW_POST_ERROR = "COUNT_PUBLISH_LAYER_VIEW_POST_ERROR";
export const LINK_USER_SUCCESS = "LINK_USER_SUCCESS";
export const LINK_USER_ERROR = "LINK_USER_ERROR";
export const LINK_USER_POST_ERROR = "LINK_USER_POST_ERROR";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_ERROR = "UPDATE_PASSWORD_ERROR";
export const UPDATE_PASSWORD_POST_ERROR = "UPDATE_PASSWORD_POST_ERROR";
export const PUBLISH_PUBLIC_SUCCESS = "PUBLISH_PUBLIC_SUCCESS";
export const PUBLISH_PUBLIC_ERROR = "PUBLISH_PUBLIC_ERROR";
export const PUBLISH_PUBLIC_POST_ERROR = "PUBLISH_PUBLIC_POST_ERROR";
export const PUBLISH_LAYER_VIEW_SUCCESS = "PUBLISH_LAYER_VIEW_SUCCESS";
export const PUBLISH_LAYER_VIEW_ERROR = "PUBLISH_LAYER_VIEW_ERROR";
export const PUBLISH_LAYER_VIEW_POST_ERROR = "PUBLISH_LAYER_VIEW_POST_ERROR";
export const COUNT_TOTAL_PUBLISH_LAYER_VIEWED_SUCCESS = "COUNT_TOTAL_PUBLISH_LAYER_VIEWED_SUCCESS";
export const COUNT_TOTAL_PUBLISH_LAYER_VIEWED_ERROR = "COUNT_TOTAL_PUBLISH_LAYER_VIEWED_ERROR";
export const COUNT_TOTAL_PUBLISH_LAYER_VIEWED_POST_ERROR = "COUNT_TOTAL_PUBLISH_LAYER_VIEWED_POST_ERROR";
export const GET_LAYER_NAME_SUCCESS = "GET_LAYER_NAME_SUCCESS";
export const GET_LAYER_NAME_ERROR = "GET_LAYER_NAME_ERROR";
export const GET_LAYER_NAME_POST_ERROR = "GET_LAYER_NAME_POST_ERROR";
export const GET_PUBLIC_LAYER_SUCCESS = "GET_PUBLIC_LAYER_SUCCESS";
export const GET_PUBLIC_LAYER_ERROR = "GET_PUBLIC_LAYER_ERROR";
export const GET_PUBLIC_LAYER_POST_ERROR = "GET_PUBLIC_LAYER_POST_ERROR";
export const GET_OWN_PUBLIC_LAYER_SUCCESS = "GET_OWN_PUBLIC_LAYER_SUCCESS";
export const GET_OWN_PUBLIC_LAYER_POST_ERROR = "GET_OWN_PUBLIC_LAYER_POST_ERROR";
export const GET_OWN_PUBLIC_LAYER_ERROR = "GET_OWN_PUBLIC_LAYER_ERROR";
export const COUNT_PUBLIC_LAYER_SUCCESS = "COUNT_PUBLIC_LAYER_SUCCESS";
export const COUNT_PUBLIC_LAYER_ERROR = "COUNT_PUBLIC_LAYER_ERROR";
export const COUNT_PUBLIC_LAYER_POST_ERROR = "COUNT_PUBLIC_LAYER_POST_ERROR";
export const REGISTER_PUBLIC_LAYER_SUCCESS = "REGISTER_PUBLIC_LAYER_SUCCESS";
export const REGISTER_PUBLIC_LAYER_ERROR = "REGISTER_PUBLIC_LAYER_ERROR";
export const REGISTER_PUBLIC_LAYER_POST_ERROR = "REGISTER_PUBLIC_LAYER_POST_ERROR";
export const GET_UPDATE_FROM_LAYER_SUCCESS = "GET_UPDATE_FROM_LAYER_SUCCESS";
export const GET_UPDATE_FROM_LAYER_ERROR = "GET_UPDATE_FROM_LAYER_ERROR";
export const GET_UPDATE_FROM_LAYER_POST_ERROR = "GET_UPDATE_FROM_LAYER_POST_ERROR";
export const GET_UPDATE_TO_LAYER_SUCCESS = "GET_UPDATE_TO_LAYER_SUCCESS";
export const GET_UPDATE_TO_LAYER_ERROR = "GET_UPDATE_TO_LAYER_ERROR";
export const GET_UPDATE_TO_LAYER_POST_ERROR = "GET_UPDATE_TO_LAYER_POST_ERROR";
export const REQUEST_UPDATE_LAYER_SUCCESS = "REQUEST_UPDATE_LAYER_SUCCESS";
export const REQUEST_UPDATE_LAYER_ERROR = "REQUEST_UPDATE_LAYER_ERROR";
export const REQUEST_UPDATE_LAYER_POST_ERROR = "REQUEST_UPDATE_LAYER_POST_ERROR";
export const COUNT_REQUEST_UPDATE_PUBLISH_URI_SUCCESS = "COUNT_REQUEST_UPDATE_PUBLISH_URI_SUCCESS";
export const COUNT_REQUEST_UPDATE_PUBLISH_URI_ERROR = "COUNT_REQUEST_UPDATE_PUBLISH_URI_ERROR";
export const COUNT_REQUEST_UPDATE_PUBLISH_URI_POST_ERROR = "COUNT_REQUEST_UPDATE_PUBLISH_URI_POST_ERROR";
export const GET_REQUEST_UPDATE_PUBLISH_URI_SUCCESS = "GET_REQUEST_UPDATE_PUBLISH_URI_SUCCESS";
export const GET_REQUEST_UPDATE_PUBLISH_URI_ERROR = "GET_REQUEST_UPDATE_PUBLISH_URI_ERROR";
export const GET_REQUEST_UPDATE_PUBLISH_URI_POST_ERROR = "GET_REQUEST_UPDATE_PUBLISH_URI_POST_ERROR";
export const APPROVE_REQUEST_UPDATE_PUBLISH_URI_SUCCESS = "APPROVE_REQUEST_UPDATE_PUBLISH_URI_SUCCESS";
export const APPROVE_REQUEST_UPDATE_PUBLISH_URI_ERROR = "APPROVE_REQUEST_UPDATE_PUBLISH_URI_ERROR";
export const APPROVE_REQUEST_UPDATE_PUBLISH_URI_POST_ERROR = "APPROVE_REQUEST_UPDATE_PUBLISH_URI_POST_ERROR";
export const DEREGISTER_PUBLIC_LAYER_SUCCESS = "DEREGISTER_PUBLIC_LAYER_SUCCESS";
export const DEREGISTER_PUBLIC_LAYER_ERROR = "DEREGISTER_PUBLIC_LAYER_ERROR";
export const DEREGISTER_PUBLIC_LAYER_POST_ERROR = "DEREGISTER_PUBLIC_LAYER_POST_ERROR";

export const REQUEST_PUBLIC_LAYER_SUCCESS = "REQUEST_PUBLIC_LAYER_SUCCESS";
export const REQUEST_PUBLIC_LAYER_ERROR = "REQUEST_PUBLIC_LAYER_ERROR";
export const REQUEST_PUBLIC_LAYER_POST_ERROR = "REQUEST_PUBLIC_LAYER_POST_ERROR";

export const COUNT_REQUEST_PUBLIC_LAYER_SUCCESS = "COUNT_REQUEST_PUBLIC_LAYER_SUCCESS";
export const COUNT_REQUEST_PUBLIC_LAYER_ERROR = "COUNT_REQUEST_PUBLIC_LAYER_ERROR";
export const COUNT_REQUEST_PUBLIC_LAYER_POST_ERROR = "COUNT_REQUEST_PUBLIC_LAYER_POST_ERROR";
export const APPROVE_REQUEST_PUBLIC_LAYER_SUCCESS = "APPROVE_REQUEST_PUBLIC_LAYER_SUCCESS";
export const APPROVE_REQUEST_PUBLIC_LAYER_ERROR = "APPROVE_REQUEST_PUBLIC_LAYER_ERROR";
export const APPROVE_REQUEST_PUBLIC_LAYER_POST_ERROR = "APPROVE_REQUEST_PUBLIC_LAYER_POST_ERROR";
export const OWNERVIEW_REQUEST_PUBLIC_LAYER_SUCCESS = "OWNERVIEW_REQUEST_PUBLIC_LAYER_SUCCESS";
export const OWNERVIEW_REQUEST_PUBLIC_LAYER_ERROR = "OWNERVIEW_REQUEST_PUBLIC_LAYER_ERROR";
export const OWNERVIEW_REQUEST_PUBLIC_LAYER_POST_ERROR = "OWNERVIEW_REQUEST_PUBLIC_LAYER_POST_ERROR";
export const USERVIEW_REQUEST_PUBLIC_LAYER_SUCCESS = "USERVIEW_REQUEST_PUBLIC_LAYER_SUCCESS";
export const USERVIEW_REQUEST_PUBLIC_LAYER_ERROR = "USERVIEW_REQUEST_PUBLIC_LAYER_ERROR";
export const USERVIEW_REQUEST_PUBLIC_LAYER_POST_ERROR = "USERVIEW_REQUEST_PUBLIC_LAYER_POST_ERROR";


export const PROJECTLIST_SUCCESS = "PROJECTLIST_SUCCESS";
export const PROJECTLIST_ERROR = "PROJECTLIST_ERROR";
export const PROJECTLIST_POST_ERROR = "PROJECTLIST_POST_ERROR";

 
export const GET_OWN_PUBLIC_LAYER_QUOTA_SUCCESS = "GET_OWN_PUBLIC_LAYER_QUOTA_SUCCESS";
export const GET_OWN_PUBLIC_LAYER_QUOTA_ERROR = "GET_OWN_PUBLIC_LAYER_QUOTA_ERROR";
export const GET_OWN_PUBLIC_LAYER_QUOTA_POST_ERROR = "GET_OWN_PUBLIC_LAYER_QUOTA_POST_ERROR"; 

 
export const CREATE_QUOTA_SUCCESS = "CREATE_QUOTA_SUCCESS";
export const CREATE_QUOTA_ERROR = "CREATE_QUOTA_ERROR";
export const CREATE_QUOTA_POST_ERROR = "CREATE_QUOTA_POST_ERROR"; 

export const CHANGE_QUOTA_STAT_SUCCESS = "CHANGE_QUOTA_STAT_SUCCESS";
export const CHANGE_QUOTA_STAT_POST_ERROR = "CHANGE_QUOTA_STAT_POST_ERROR";
export const CHANGE_QUOTA_STAT_ERROR = "CHANGE_QUOTA_STAT_ERROR"; 

export const CHANGE_SETTING_STAT_SUCCESS = "CHANGE_SETTING_STAT_SUCCESS";
export const CHANGE_SETTING_STAT_POST_ERROR = "CHANGE_SETTING_STAT_POST_ERROR";
export const CHANGE_SETTING_STAT_ERROR = "CHANGE_SETTING_STAT_ERROR"; 

export const GET_SUBSCRIPTION_SUCCESS = "GET_SUBSCRIPTION_SUCCESS";
export const GET_SUBSCRIPTION_POST_ERROR = "GET_SUBSCRIPTION_POST_ERROR";
export const GET_SUBSCRIPTION_ERROR = "GET_SUBSCRIPTION_ERROR"; 

export const UPLOAD_TIFF_ERROR = "UPLOAD_TIFF_ERROR";
export const UPLOAD_TIFF_SUCCESS = "UPLOAD_TIFF_SUCCESS";
export const UPLOAD_TIFF_POST_ERROR = "UPLOAD_TIFF_POST_ERROR";

export const TILE_TIFF_ERROR = "TILE_TIFF_ERROR";
export const TILE_TIFF_SUCCESS = "TILE_TIFF_SUCCESS";
export const TILE_TIFF_RETRIEVE_SUCCESS = "TILE_TIFF_RETRIEVE_SUCCESS";
export const TILE_TIFF_POST_ERROR = "TILE_TIFF_POST_ERROR";

export const CHECK_FILE_ERROR = "CHECK_FILE_ERROR";
export const CHECK_FILE_SUCCESS = "CHECK_FILE_SUCCESS";
export const CHECK_FILE_POST_ERROR = "CHECK_FILE_POST_ERROR";

export const DOWNLOAD_HOTSPOT_ERROR = "DOWNLOAD_HOTSPOT_ERROR";
export const DOWNLOAD_HOTSPOT_SUCCESS = "DOWNLOAD_HOTSPOT_SUCCESS";
export const DOWNLOAD_HOTSPOT_POST_ERROR = "DOWNLOAD_HOTSPOT_POST_ERROR";


export const GET_ALL_COMPANY_ERROR = "GET_ALL_COMPANY_ERROR";
export const GET_ALL_COMPANY_SUCCESS = "GET_ALL_COMPANY_SUCCESS";
export const GET_ALL_COMPANY_POST_ERROR = "GET_ALL_COMPANY_POST_ERROR";
export const NEW_COMPANY_SUCCESS = "NEW_COMPANY_SUCCESS";


export const GET_ALL_USERS_ERROR = "GET_ALL_USERS_ERROR";
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_POST_ERROR = "GET_ALL_USERS_POST_ERROR";
export const NEW_USER_SUCCESS = "NEW_USER_SUCCESS";


export const ADD_NEW_FORM_ERROR = "ADD_NEW_FORM_ERROR";
export const ADD_NEW_FORM_SUCCESS = "ADD_NEW_FORM_SUCCESS";
export const ADD_NEW_FORM_POST_ERROR = "ADD_NEW_FORM_POST_ERROR";
export const GET_ALL_REPORT_SUCCESS = "GET_ALL_REPORT_SUCCESS"; 


export const GET_ALL_HOTSPOT_ERROR = "GET_ALL_HOTSPOT_ERROR";
export const GET_ALL_MODIS_SUCCESS = "GET_ALL_MODIS_SUCCESS";
export const GET_ALL_HOTSPOT_POST_ERROR = "GET_ALL_HOTSPOT_POST_ERROR"; 

export const GET_ALL_HOTSPOT_VIIRS_ERROR = "GET_ALL_HOTSPOT_ERROR";
export const GET_ALL_VIIRS_SUCCESS = "GET_ALL_VIIRS_SUCCESS";
export const GET_ALL_HOTSPOT_VIIRS_POST_ERROR = "GET_ALL_HOTSPOT_POST_ERROR";



export const GET_ALL_HOTSPOT_NOAA_ERROR = "GET_ALL_HOTSPOT_NOAA_ERROR"; 
export const GET_ALL_NOAA_SUCCESS = "GET_ALL_NOAA_SUCCESS";
export const GET_ALL_HOTSPOT_NOAA_POST_ERROR = "GET_ALL_HOTSPOT_NOAA_POST_ERROR"; 

export const GET_FILTERED_HOTSPOT_ERROR = "GET_FILTERED_HOTSPOT_ERROR";
export const GET_FILTERED_HOTSPOT_SUCCESS = "GET_FILTERED_HOTSPOT_SUCCESS"; 
export const GET_FILTERED_HOTSPOT_POST_ERROR = "GET_FILTERED_HOTSPOT_POST_ERROR"; 
export const GET_FILTERED_CSV_HOTSPOT_SUCCESS = "GET_FILTERED_CSV_HOTSPOT_SUCCESS"; 

export const GET_CONC_FORM_ERROR = "GET_CONC_FORM_ERROR";
export const GET_CONC_FORM_SUCCESS = "GET_CONC_FORM_SUCCESS"; 
export const GET_CONC_FORM_POST_ERROR = "GET_CONC_FORM_POST_ERROR"; 


export const EDIT_USER_INFO_ERROR = "EDIT_USER_INFO_ERROR";
export const EDIT_USER_INFO_SUCCESS = "EDIT_USER_INFO_SUCCESS"; 
export const EDIT_USER_INFO_POST_ERROR = "EDIT_USER_INFO_POST_ERROR"; 

export const EDIT_COMPANY_INFO_ERROR = "EDIT_COMPANY_INFO_ERROR";
export const EDIT_COMPANY_INFO_SUCCESS = "EDIT_COMPANY_INFO_SUCCESS"; 
export const EDIT_COMPANY_INFO_POST_ERROR = "EDIT_COMPANY_INFO_POST_ERROR"; 


export const GET_REPORT_LIST_ERROR = "GET_REPORT_LIST_ERROR";
export const GET_REPORT_LIST_SUCCESS = "GET_REPORT_LIST_SUCCESS"; 
export const GET_REPORT_LIST_POST_ERROR = "GET_REPORT_LIST_POST_ERROR"; 
export const GET_REPORT_CSV_LIST_SUCCESS = "GET_REPORT_CSV_LIST_SUCCESS"; 
export const GET_REPORT_SHAPE_LIST_SUCCESS = "GET_REPORT_SHAPE_LIST_SUCCESS"; 

export const GET_GROUP_LIST_ERROR = "GET_GROUP_LIST_ERROR";
export const GET_GROUP_LIST_SUCCESS = "GET_GROUP_LIST_SUCCESS"; 
export const GET_GROUP_LIST_POST_ERROR = "GET_GROUP_LIST_POST_ERROR"; 



export const SUBMIT_CONC_FORM_ERROR = "SUBMIT_CONC_FORM_ERROR";
export const SUBMIT_CONC_FORM_SUCCESS = "SUBMIT_CONC_FORM_SUCCESS"; 
export const SUBMIT_CONC_FORM_POST_ERROR = "SUBMIT_CONC_FORM_POST_ERROR"; 


export const EMAIL_VIEW_ERROR = "EMAIL_VIEW_ERROR";
export const EMAIL_VIEW_POST_ERROR = "EMAIL_VIEW_POST_ERROR"; 
export const EMAIL_VIEW_SUCCESS = "EMAIL_VIEW_SUCCESS"; 
export const EMAIL_EDIT_SUCCESS = "EMAIL_EDIT_SUCCESS"; 
export const EMAIL_EDIT_ERROR = "EMAIL_EDIT_ERROR"; 

export const PLANTATION_VIEW_ERROR = "PLANTATION_VIEW_ERROR";
export const PLANTATION_VIEW_POST_ERROR = "PLANTATION_VIEW_POST_ERROR"; 
export const PLANTATION_VIEW_SUCCESS = "PLANTATION_VIEW_SUCCESS"; 
export const PLANTATION_EDIT_SUCCESS = "PLANTATION_EDIT_SUCCESS"; 
export const PLANTATION_EDIT_ERROR = "PLANTATION_EDIT_ERROR";  

export const CREATE_PLANTATION_SUCCESS = "CREATE_PLANTATION_SUCCESS";
export const CREATE_PLANTATION_POST_ERROR = "CREATE_PLANTATION_POST_ERROR";
export const CREATE_PLANTATION_ERROR = "CREATE_PLANTATION_ERROR";


export const COUNTRY_VIEW_ERROR = "COUNTRY_VIEW_ERROR";
export const  COUNTRY_VIEW_POST_ERROR = "COUNTRY_VIEW_POST_ERROR"; 
export const  COUNTRY_VIEW_SUCCESS = "COUNTRY_VIEW_SUCCESS"; 



// WEBPACK FOOTER //
// ./src/actions/types.js